const LocalStorageKeys = {
  LOCALIZATION: 'localization',
  WELCOME_ORGANIZATION: 'welcomeOrganization',
  USER_IAM_CLIENT_ID: 'user-iam-client-id',
  USER_AUTH_DOMAIN: 'user-auth-domain',
  USER_LAST_SELECTED_ORGANIZATION_ID: 'user-last-selected-organization-id',
};

export const NEED_CLEAR_AFTER_LOGOUT_DATA_KEYS = [
  LocalStorageKeys.USER_IAM_CLIENT_ID,
  LocalStorageKeys.USER_AUTH_DOMAIN,
  LocalStorageKeys.USER_LAST_SELECTED_ORGANIZATION_ID,
];

export default LocalStorageKeys;
